<template>
  <div class="page flex-col">
    <div class="group_1 flex-col" style="padding-top: 0;">
      <v-head :title="title" :state="stateRedirect"></v-head>
      <div class="group_29 flex-col">
        <div class="group_2 flex-col">
          <span class="paragraph_1">{{ meetingDetail.name }}</span>
          <div class="image-text_25 flex-row justify-between">
            <van-icon class="icon_2" name="todo-list-o" />
            <div class="text-group_2">
              <span class="text_4">举办时间：</span>
              <span class="text_5">{{ meetingDetail.startDate | changeTime }}-{{
                meetingDetail.endDate | changeTime
                }}</span>
            </div>
          </div>
          <div class="image-text_26 flex-row justify-between">
            <van-icon name="location-o" class="icon_3" />

            <div class="text-group_3">
              <span class="text_6">举办地点：</span>
              <span class="text_7">{{ meetingDetail.provinceName }}-{{
                meetingDetail.cityName
                }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="group_28 flex-col">
        <span class=" box_3 text_8" style="-webkit-align-self: flex-start;width: 86%;display: block;">基本信息</span>
        <!-- <van-notice-bar style="margin: 0 0.21333rem 0 0.21333rem"
          left-icon="info-o">联系人信息是主办方与您取得联系的重要方式，请仔细填写。</van-notice-bar> -->
        <!-- <van-form class=" group_29" style="padding-top: 0;padding-bottom: 0;">
          <van-field v-model="userParams.pic" required label="姓名" placeholder="姓名"
            :rules="[{ required: true, message: '请填写姓名' }]" />
          <van-field required v-model="userParams.mobile" @blur="checkPhone" id="telphone" v-telphone label="手机号"
            placeholder="请输入手机号码" :rules="[{ required: true, message: '请填写手机号码' }]"></van-field>
          </van-field>
          <van-field v-if="!loginStatus" class="codesms" required @input="checkCode()" v-model="userParams.messageCode"
            label="验证码" placeholder="请输入验证码">
            <van-button v-if="!codeStatus" slot="button" plain size="small" @click="getCode">
              <template v-if="!isSpend">
                <div class="button-3 text-70">获取验证码</div>
              </template>
              <template v-else>
                <div class="button-6 text-71">重新发送( {{ time }} )</div>
              </template>
            </van-button>
            <van-button v-if="codeStatus" slot="button" plain size="small">
              <template>
                <div class="button-3 text-70">验证通过</div>
              </template>
            </van-button>
          </van-field>
        </van-form> -->
        <personAdvancedForm class=" group_29" style="padding-top: 0;padding-bottom: 0;"
          :ruleForm.sync="personDetailForm" :unitDetail="settingPersonDetail" :loginStatus="loginStatus"
          ref="personValidate">
        </personAdvancedForm>
      </div>

      <!-- 分会场 -->
      <div class="group_29 flex-col" style="padding-top: 0 ;" v-if="meetingPlaceDTOs[0]">
        <div class="group_2 flex-col">
          <div class="block_9 flex-row justify-between">
            <span class="text_47">分会场信息</span>

          </div>
        </div>
        <van-collapse v-model="activeNames" accordion>
          <template>
            <van-collapse-item accordion title="分会场">
              <!-- 同一时刻只能选一个分会场 -->
              <div style="padding: 0.27rem 0.42rem;">
                <van-checkbox-group v-model="PlaceParams" direction="horizontal" @change="placeChange">
                  <template v-for="itemV in meetingPlaceDTOs">
                    <van-checkbox :disabled="disabledPlaceId(itemV.id)" :key="itemV.id" :name="itemV.id">{{
                      itemV.name
                      }}</van-checkbox>
                  </template>
                </van-checkbox-group>
              </div>
              <!-- 只能选一个分会场 -->
              <!-- <div>
                <van-radio-group v-model="PlaceParams[0]" direction="horizontal">
                  <template v-for="itemV in meetingPlaceDTOs2[0]?meetingPlaceDTOs2[0].meetingPlaceList:[]">
                    <van-radio :key="itemV.id" :name="itemV.id">{{
                      itemV.name
                      }}</van-radio>
                  </template>
                </van-radio-group>
              </div> -->
              <!-- 无限制 -->
              <!-- <div>
                <van-checkbox-group v-model="PlaceParams[0]" shape="square" direction="horizontal">
                  <van-checkbox v-for="itemV in meetingPlaceDTOs2[0]?meetingPlaceDTOs2[0].meetingPlaceList:[]"
                    :key="itemV.id" :value="itemV.id" :name="itemV.id">{{
                    itemV.name
                    }}</van-checkbox>
                </van-checkbox-group>
              </div> -->
            </van-collapse-item>
          </template>
        </van-collapse>

      </div>
      <!-- 发票 -->
      <div class="group_29 flex-col" style="padding-top: 0;" v-if="meetingDetail.duesType==2">
        <div class=" flex-col">
          <div class="group_2">
            <span class=" text_8">发票</span>
          </div>
          <div class="group_12 flex-row">
            <van-field v-model="userParams.invoiceInfo" is-link readonly required name="invoiceInfo" label="发票信息"
              placeholder="填写发票信息" @click="addinvoice()" />
          </div>
        </div>
        <div></div>
        <van-popup class="invoice" v-model="showBottom" closeable :close-on-click-overlay="false" position="bottom">
          <van-form @submit="admitInvoice" ref="admitInvoice">
            <div style="margin-top: 1.5rem ;padding-bottom: 0; " class=" flex-col group_1 group_29">
              <div class="group_1 flex-col">
                <div class="group_2 " style="padding-left: 0;padding-right: 0;">
                  <p class="text_2">发票详情</p>
                  <div class=" text-wrapper_2 flex-col">
                    <van-field name="radio" required :rules="[{ required: true, message: '请选择抬头类型' }]" label="抬头类型">
                      <template #input>
                        <van-radio-group v-model="invoiceParams.type" @change="changeInvoiceType" direction="horizontal"
                          style="margin-left: 0;">
                          <van-radio :name="2">单位 </van-radio>
                          <van-radio :name="1">个人</van-radio>
                        </van-radio-group>
                      </template>
                    </van-field>
                    <van-field required v-model="invoiceParams.invoiceCompanyName" label="发票抬头" placeholder="请输入发票抬头"
                      :rules="[{ required: true, message: '请输入发票抬头' }]" />
                    <van-field @blur="checkTin" maxlength="20" v-if="invoiceParams.type == 2" required
                      v-model="invoiceParams.tin" label="纳税人识别号" placeholder="请输入纳税人识别号" :rules="[
                        { required: true, message: '请输入纳税人识别号' },
                      ]" />
                    <van-field disabled v-if="invoiceParams.type == 2" v-model="invoiceParams.info" label="更多内容"
                      placeholder="填写注册地址、电话等（非必填）" @click="show = true" class="more" />
                  </div>
                </div>
              </div>
              <van-dialog class="moredialog" v-model="show" confirmButtonText="保存" @confirm="saveNorequired">
                <div class="box_2 flex-row justify-between" style="margin-left: 2.7rem;">
                  <span class="text_22">更多内容</span>
                  <van-icon name="cross" class="icon_1" @click="show = false" />
                </div>
                <!-- abc -->
                <div class="block_1 flex-col ">
                  <van-field label-class="label-justify" v-model="invoiceParams.invoiceBank" label="开户银行"
                    maxlength="100" placeholder="选填">
                  </van-field>
                  <van-field label-class="label-justify" id="valueInput" v-Alphabet maxlength="100"
                    v-model="invoiceParams.invoiceAccount" label="银行账号" placeholder="选填" />
                  <van-field label-class="label-justify" v-model="invoiceParams.invoiceAddress" label="单位地址"
                    maxlength="100" placeholder="选填" />
                  <van-field label-class="label-justify" id="gudtel" v-gudtel maxlength="30"
                    v-model="invoiceParams.invoiceTelephone" label="电话号码" placeholder="选填" />
                  <van-field label-class="label-justify" maxlength="65" type="textarea" autosize
                    v-model="invoiceParams.invoiceRemarks" label="备注" placeholder="选填" />
                </div>
                <div class="box-1 flex-row "
                  style="margin: 0 0 10px;display: flex;justify-content: center;width: 100%;">
                  <button class="button-5 flex-col" @click.prevent="saveNorequired">
                    <span class="text_37">保存</span>
                  </button>
                </div>
              </van-dialog>
            </div>
            <div class="group_1 group_29 flex-col " style="padding-top: 0;">
              <div class=" group_2 flex-col " style="padding: 6px;">
                <p class="text_2" style="margin-bottom: 0.3rem;">取票方式</p>
                <div class=" text-wrapper_2 flex-col " v-if="invoiceParams.invoiceType == 2">
                  <!-- <van-radio-group
                    v-model="invoiceParams.deliveryType"
                    direction="horizontal"
                    style="margin-bottom: 10px;"
                  >
                    <van-radio :name="3">请在开票记录中下载发票</van-radio>
                  </van-radio-group> -->
                  <van-notice-bar left-icon="info-o">请在开票记录中下载发票</van-notice-bar>
                  <!-- <div class=" text-wrapper_2 flex-col justify-between">
              <van-fieldinvoiceTyp
              label="电子邮箱"
              required
              clearable
              input-align="right"
              v-model="invoiceParams.deliveryEmail"
              placeholder="请输入电子邮箱"
              :rules="[{ required: true, message: '请输入电子邮箱' }]"
             />
             </div> -->
                </div>
                <div class=" text-wrapper_2 flex-col justify-between" v-if="invoiceParams.invoiceType == 1">
                  <div>
                    <van-radio-group v-model="invoiceParams.deliveryType" direction="horizontal">
                      <van-radio name="1">邮寄</van-radio>
                      <van-radio name="2">现场取票</van-radio>
                    </van-radio-group>
                    <div v-if="invoiceParams.deliveryType == 1" class=" text-wrapper_2 flex-col ">
                      <van-field required v-model="invoiceParams.deliveryContact" label="收件人" placeholder="请输入收件人"
                        :rules="[{ required: true, message: '请输入收件人' }]" />
                      <van-field required v-model="invoiceParams.deliveryMobile" label="手机号" placeholder="请输入手机号"
                        :rules="[{ required: true, message: '请输入手机号' }]" />
                      <van-field required v-model="invoiceParams.deliveryDetailedAddress" label="邮寄地址"
                        placeholder="填写邮寄地址" :rules="[{ required: true, message: '填写邮寄地址' }]" />
                    </div>
                    <van-notice-bar v-if="invoiceParams.checkedGetType2 == 2"
                      left-icon="info-o">抵达会议现场，您可通过提供联系人方式或单位名称向工作人员索要发票.</van-notice-bar>
                  </div>
                </div>
              </div>
              <button class="button-1 flex-col" style="margin-left: 0;width: 100%;" @click="admitInvoice()">
                <span class="text_14">确认提交</span>
              </button>
            </div>
          </van-form>


        </van-popup>
      </div>




      <!-- 酒店 -->
      <div class="group_29 flex-col" style="padding-top: 0 ;" v-if="meetingHotelDTOs[0]">
        <div class="group_2 flex-col">
          <div class="block_9 flex-row justify-between">
            <span class="text_47">酒店入住信息</span>
            <div class="image-text_27 flex-row justify-between" style="display: flex;align-items: end;">
              <van-checkbox shape="square" name="1" v-model="Checkbox_checkbox_1" checked-color=""
                class="checkbox_1 Checkbox" @change="noOrder()"></van-checkbox><span class="text-group_4">不预定</span>
            </div>
          </div>
        </div>
        <van-collapse v-model="activeNames" accordion>
          <template>
            <van-collapse-item v-for="hotel in meetingHotelDTOs" :key="hotel.id" :name="hotel.id" accordion
              :disabled="Checkbox_checkbox_1 == 1">
              <template #title>
                <div>
                  <van-icon name="play" />
                  <span>{{ hotel.name }}</span>
                  <span class="text_53" style="position: absolute; right: 1.1rem;">
                    已选择{{
                    hotel.HotelParamsList[0].orderNum +
                    hotel.HotelParamsList[1].orderNum
                    }}
                    间</span>
                </div>
              </template>
              <div class="holetinfo">
                <div class="block_6 flex-row">
                  <div class="image-text_29 flex-row justify-between">
                    <van-icon class="icon_6" name="hotel-o" />
                    <!-- <img  referrerpolicy="no-referrer" src="../../../assets/images/hotel.png" /> -->
                    <span class="text-group_6">酒店地址</span>
                  </div>
                  <span class="text_49" style="color: black;">{{
                    hotel.address
                    }}</span>
                  <!-- abc -->
                </div>
                <div class="block_6 flex-row justify-between">
                  <div class="image-text_29 flex-row justify-between">
                    <van-icon class="icon_6" name="phone-o" />
                    <!-- <img  referrerpolicy="no-referrer" src="../../../assets/images/tel.png" /> -->
                    <span class="text-group_6">联系电话</span>
                    <span class="text_49" style="color: black;">{{
                      hotel.telephone
                      }}</span>
                  </div>

                  <div @click="copy(hotel.telephone)" v-if="hotel.telephone">
                    <img class="pagehotelcopy" referrerpolicy="no-referrer" src="../../../assets/images/copy.png" />
                  </div>
                </div>

                <div class="block_6 flex-row justify-between">
                  <div class="image-text_29 flex-row justify-between">
                    <van-icon class="icon_6" name="location-o" />
                    <!-- <img referrerpolicy="no-referrer" src="../../../assets/images/internet.png" /> -->
                    <span class="text-group_6" style="color: black;">酒店网址</span>
                    <span class="text_49" style="color: black;">{{
                      hotel.hotelUrl
                      }}</span>
                  </div>
                  <div @click="copy(hotel.hotelUrl)" v-if="hotel.hotelUrl">
                    <img class="pagehotelcopy" referrerpolicy="no-referrer" src="../../../assets/images/copy.png" />
                  </div>
                </div>
              </div>
              <van-divider />
              <div class="group-8 flex-row justify-between">
                <span class="text_52">预定数量：单间*{{
                  hotel.HotelParamsList[0].orderNum
                  }}
                  标间*{{ hotel.HotelParamsList[1].orderNum }}
                </span>
                <!-- 除了已选择的酒店其他酒店均不显示预订 -->
                <button v-if="!(disabledHotel&& hotel.HotelParamsList[0].orderNum == 0 &&
                    hotel.HotelParamsList[1].orderNum == 0)" class="button-2 flex-col" @click="showHotelClick(hotel)">
                  <span v-if="
                      hotel.HotelParamsList[0].orderNum > 0 ||
                        hotel.HotelParamsList[1].orderNum > 0
                    " class="text_53">修改预定</span>
                  <span v-else class="text_53">预定</span>
                </button>
              </div>
            </van-collapse-item>
          </template>
        </van-collapse>
        <van-popup v-model="showHotel" closeable :close-on-click-overlay="false" position="bottom"
          :style="{ height: '90%' }" @click-close-icon="closeHotel" class="hotel">
          <van-form @submit="submitHotel" ref="submitHotel">
            <div style="margin-top: 0.3rem ;padding-top: 0; " class=" flex-col  group_29">
              <div class=" group_2 flex-col " style="padding: 6px;">
                <p class="text_2" style="margin-bottom: 0.3rem;">
                  {{ HotelParamsList[0].name }}
                </p>
                <van-notice-bar left-icon="info-o"
                  style="margin: 0;background:transparent;">主办方会提前预留房间方便您就近入驻</van-notice-bar>
              </div>
              <div class=" flex-col">
                <div class="group_2 ">
                  <div style="display: flex;align-items: center;padding-bottom: 0.3rem;">
                    <div class="titles"></div>
                    <span class="text_2" style="margin: 0 0.2rem;">单间</span>
                  </div>
                  <div class=" text-wrapper_2 flex-col">
                    <div class="titles-1">
                      <div>
                        <span>房型描述</span>
                        <span style="margin-left: 21px;">{{
                          HotelParamsList[0].singleRemarks
                          }}</span>
                      </div>

                    </div>
                    <van-field class="justify-between " name="stepper" label="预定数量">
                      <template #input>
                        <van-stepper v-model="HotelParamsList[0].orderNum" min="0" max="1"
                          @change="changeSingle($event, 0)" :disabled="disabledHotel&&HotelParamsList[0].orderNum==0" />
                      </template>
                    </van-field>
                    <!-- 单间入住 -->
                    <van-field name="singleIn" class="justify-between time" @click="showcalendar1 = true"
                      v-model="HotelParamsList[0].startDate" label="预计入住时间"
                      :required="HotelParamsList[0].orderNum > 0 ? true : false" placeholder="请选择预计入住时间"
                      @focus="noBomBox" :rules="[
                        {
                          required: singleStatus,
                          message: '请选择预计入住时间',
                        },
                      ]">
                    </van-field>
                    <van-calendar v-model="showcalendar1" @confirm="onConfirm1" />
                    <!-- 单间退费 -->
                    <van-field name="singleOut" class="justify-between time" @click="showcalendar2 = true"
                      v-model="HotelParamsList[0].endDate" label="预计退房时间"
                      :required="HotelParamsList[0].orderNum > 0 ? true : false" placeholder="请选择预计退房时间"
                      @focus="noBomBox" :rules="[
                        {
                          required: singleStatus,
                          message: '请选择预计退房时间',
                        },
                      ]">
                    </van-field>
                    <van-calendar v-model="showcalendar2" @confirm="onConfirm2" />
                  </div>
                </div>
                <div class=" flex-col">
                  <div class="group_2 ">
                    <div style="display: flex;align-items: center;padding-bottom: 0.3rem;">
                      <div class="titles"></div>
                      <span class="text_2" style="margin: 0 0.2rem;">标间</span>
                    </div>
                    <div class=" text-wrapper_2 flex-col ">
                      <div class="titles-1">
                        <div>
                          <span>房型描述</span>
                          <span style="margin-left: 21px;">{{
                            HotelParamsList[1].standardRemarks
                            }}</span>
                        </div>
                      </div>
                      <van-field class="justify-between" name="stepper" label="预定数量">
                        <template #input>
                          <van-stepper v-model="HotelParamsList[1].orderNum" min="0" max="1"
                            @change="changeSimple($event, 1)"
                            :disabled="disabledHotel&&HotelParamsList[1].orderNum==0" />
                        </template>
                      </van-field>
                      <!-- 单间入住 -->
                      <van-field name="simpleIn" class="justify-between time" @click="showcalendar3 = true"
                        v-model="HotelParamsList[1].startDate" label="预计入住时间" :required="
                          HotelParamsList[1].orderNum > 0 ? true : false
                        " placeholder="请选择预计入住时间" @focus="noBomBox" :rules="[
                          {
                            required: simpleStatus,
                            message: '请选择预计入住时间',
                          },
                        ]">
                      </van-field>
                      <van-calendar v-model="showcalendar3" @confirm="onConfirm3" />
                      <!-- 单间退费 -->
                      <van-field name="simpleOut" class="justify-between time" @click="showcalendar4 = true"
                        v-model="HotelParamsList[1].endDate" label="预计退房时间" :required="
                          HotelParamsList[1].orderNum > 0 ? true : false
                        " placeholder="请选择预计退房时间" @focus="noBomBox" :rules="[
                          {
                            required: simpleStatus,
                            message: '请选择预计退房时间',
                          },
                        ]">
                      </van-field>
                      <van-calendar v-model="showcalendar4" @confirm="onConfirm4" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="section_4 flex-row justify-between">
                <button class="button_7 flex-col" @click="closeHotel">
                  <span class="text_9">返回</span></button><button class="button_8 flex-col" @click="submitHotel()">
                  <span class="text_9">提交</span>
                </button>
              </div>
            </div>
          </van-form>
        </van-popup>
      </div>

      <div style="width: 100%;text-align: center;">
        <button :disabled="submitdisabled" class="button_4 flex-col" @click="submitRegister">
          <span class="text_75">立即报名</span>
        </button>
      </div>


      <!-- <div class="block_9 flex-col">
      <button class="button_3 flex-col" @click="onClick_4">
        <span class="text_66">增加报名人数</span>
      </button>
    </div> -->
    </div>

  </div>
</template>
<script>
  import Vue from "vue"
  import vHead from "../../../components/Subhead.vue"
  import {
    getRegisterCode,
    // checkRegisterCode,
    getMobileLoginCode,
  } from "@/api/login"
  import {
    getMeetingDetail,
    getDivisionData,
    getMeetingSettings,
    getDictionaryByCode,
    signeGroupRegister,
    // getNormal,
    // getRegisterdetail,
    getUser,
    getPZUrl
  } from "@/api/dictionary"
  import { mapActions, mapMutations } from "vuex"
  import personAdvancedForm from "@/views/MeetingCenter/companySignUp/advancedForm"
  import {
    Form,
    Icon,
    Field,
    Button,
    Toast,
    Tabs,
    Tab,
    Dialog,
    Radio,
    NavBar,
    Popup,
    Area,
    Cell,
    Checkbox,
    Divider,
    CheckboxGroup,
    Collapse,
    CollapseItem,
    RadioGroup,
    NoticeBar,
    Stepper,
    Calendar,
    Picker,
  } from "vant"
  Vue.directive("Alphabet", {
    inserted: function (el) {
      const input = el.querySelector("#valueInput")
      input.onkeyup = function (e) {
        input.value = input.value.replace(/[^0-9]/g, "")
      }
      input.onblur = function (e) {
        input.value = input.value.replace(/[^0-9]/g, "")
      }
    },
  })
  Vue.directive("gudtel", {
    inserted: function (el) {
      const input = el.querySelector("#gudtel")
      input.onkeyup = function (e) {
        input.value = input.value.replace(/[^0-9]/g, "")
      }
      input.onblur = function (e) {
        input.value = input.value.replace(/[^0-9]/g, "")
      }
    },
  })
  Vue.directive("telphone", {
    inserted: function (el) {
      const input = el.querySelector("#telphone")
      input.onkeyup = function (e) {
        input.value = input.value.replace(/[^1[3|4|5|8][0-9]\d{4,8}$]/g, "")
      }
      input.onblur = function (e) {
        input.value = input.value.replace(/[^1[3|4|5|8][0-9]\d{4,8}$]/g, "")
      }
    },
  })
  export default {
    data() {
      return {
        submitdisabled: false,
        restaurants: [],
        state: "",
        timeout: null,
        Checkbox_checkbox_1: false,
        Checkbox_checkbox_2: false,
        Checkbox_checkbox_3: false,
        Checkbox_checkbox_4: false,
        constants: {},
        showArea: false,
        showBottom: false,
        result: "",
        time: "",
        isSpend: false,
        title: "报名",
        userParams: {
          pic: "",
          name: "",
          code: "",
          province: null,
          mobile: "",
          messageCode: "",
          invoiceInfo: null,
          userType: 2,
        },
        // 发票数据
        show: false,
        checked: "",
        username: "",
        telephone: "",
        address: "",
        invoiceParams: {
          checkedGetType1: "", //取票方式
          checkedGetType2: "", //取票方式
          type: 2,
          username: "",
          invoiceRemarks: "",
          invoiceCompanyName: "",
          tin: "",
          telephone: "",
          email: "",
          mobile: "",
          info: "已填写0项",
          invoiceType: 2,
          deliveryType: 3,
          deliveryContact: "",
          deliveryMobile: "",
        },
        // 报名人
        showedit: false,
        index: 0,
        // peopleList:[
        //   {
        //     now:'',
        //     username:'',
        //     position:'',
        //     telephone:'',
        //     gender:''
        //   }
        // ],

        // 酒店
        disabledHotel: false,//酒店只允许选择一间
        showHotel: false,
        isreport: "",
        activeNames: "",
        showcalendar1: false,
        showcalendar2: false,
        showcalendar3: false,
        showcalendar4: false,
        singleStatus: false, //单间是否需校验
        simpleStatus: false, //标间是否需校验
        HotelParamsList: [
          {
            name: "",
            singleRemarks: "",
            hotelId: "",
            roomType: 2, //单间
            orderNum: 0,
            startDate: null,
            endDate: null,
          },
          {
            name: "",
            standardRemarks: "",
            hotelId: "",
            roomType: 1, //标间
            orderNum: 0,
            startDate: null,
            endDate: null,
          },
        ],
        other: {
          need: "",
          like: [],
        },
        memberId: null,
        meetingDetail: {},
        pickerField: undefined,
        selectModel: false,
        selectKey: "", //所选择的字段
        key: "name", //选择弹窗显示对应的参数名
        columns: [],
        allAddress: [],
        codeStatus: false,
        settingPersonDetail: [],
        personDetail: [],
        personDetailForm: {
          name: '',
          mobile: '',
          code: ''
        },
        INVOICE_TYPE: [],
        registerId: null,
        loginStatus: false, //默认未登录
        amount: 0,
        meetingPlaceDTOs: [],
        disabledMeetingPlaceId: [],
        meetingHotelDTOs: [],
        PlaceParams: [],
        placeTypeName: '',
        roomNum: 0,
        stateRedirect: ""
      }
    },

    components: {
      vHead,
      [Dialog.Component.name]: Dialog.Component,
      [NavBar.name]: NavBar,
      [NoticeBar.name]: NoticeBar,
      [Icon.name]: Icon,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [Form.name]: Form,
      [Radio.name]: Radio,
      [Cell.name]: Cell,
      [Field.name]: Field,
      [Button.name]: Button,
      [Stepper.name]: Stepper,
      [Collapse.name]: Collapse,
      [CollapseItem.name]: CollapseItem,
      [Toast.name]: Toast,
      [Popup.name]: Popup,
      [Divider.name]: Divider,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Area.name]: Area,
      [RadioGroup.name]: RadioGroup,
      [Picker.name]: Picker,
      [Calendar.name]: Calendar,
      personAdvancedForm,
    },
    computed: {
      meetingId: {
        get() {
          return this.$route.query && this.$route.query.meetingId

        },
        set() {

        }
      },
      province() {
        return (provinceValue) =>
          this.allAddress.filter((item) => item.value === provinceValue).pop()
      },
      sheng() {
        return this.allAddress.filter((item) => item.level === 1)
      },
      shi() {
        return (sheng) => {
          let province = this.province(sheng)
          return province
            ? this.allAddress.filter((item) => item.parentId === province.id)
            : []
        }
      },
      shi1() {
        return this.allAddress.filter((item) => {
          return item.parentId === this.sheng[0].id
        })
      },
    },
    created() {
      getDivisionData().then((res) => {
        this.allAddress = res.result
      })
      getDictionaryByCode("INVOICE_TYPE").then((res) => {
        if (res.success) {
          this.INVOICE_TYPE = res.result
        }
      })
    },
    methods: {
      ...mapActions(["securityCheck"]),
      ...mapMutations(["setMemberInfo"]),
      getMeeting() {
        if (this.meetingId) {
          getMeetingDetail({ meetingId: this.meetingId }).then((res) => {
            this.meetingDetail = res.result.meetingDTO;
            this.meetingPlaceDTOs = res.result.meetingPlaceDTOs
            getPZUrl({ id: this.meetingDetail.photoId }).then((res) => {
              this.photoId = res.result;
            });
            this.meetingHotelDTOs = res.result.meetingHotelDTOs
            this.meetingHotelDTOs.filter((item) => {
              item.HotelParamsList = [
                {
                  name: item.name,
                  singleRemarks: item.singleRemarks,
                  hotelId: item.id,
                  roomType: 2, //单间
                  orderNum: 0,
                  startDate: null,
                  endDate: null,
                },
                {
                  name: item.name,
                  standardRemarks: item.standardRemarks,
                  hotelId: item.id,
                  roomType: 1, //标间
                  orderNum: 0,
                  startDate: null,
                  endDate: null,
                },
              ]
            })
            // this.$route.meta.title = res.result.meetingDTO.name
            console.log(document.title)
            document.title = res.result.meetingDTO.name

            if (res.result.meetingAffairDTO) {
              this.meetingAffairDetail = res.result.meetingAffairDTO
              let reg = new RegExp(/style\s*?=\s*?([‘"])[\s\S]*?\1/, "g")
              if (this.meetingAffairDetail.meetingInfo) {
                this.meetingAffairDetail.meetingInfo = this.meetingAffairDetail.meetingInfo.replace(
                  reg,
                  ""
                )
              }
            }
          });

        }
      },
      noBomBox() {
        document.activeElement.blur()
      },
      checkPhone() {
        var phone = document.getElementById("telphone").value
        if (!/^1[3456789]\d{9}$/.test(phone)) {
          Toast.fail("请输入正确的手机号！")
          return false
        }
      },
      checkTin() {
        if (!/^[0-9a-zA-Z]{1,20}$/.test(this.invoiceParams.tin)) {
          Toast.fail("请输入正确的纳税人识别号！")
          return false
        }
      },

      copy(str) {
        console.log("str", str)
        const inputNode = document.createElement("input")
        inputNode.value = str
        document.body.appendChild(inputNode)
        inputNode.select()
        document.execCommand("Copy")
        Toast.success("复制成功") //这是element plus提示用户复制成功的信息提醒，根据自己实际需求加
        document.body.removeChild(inputNode)
      },
      // querySearchAsync(queryString, cb) {
      //   if (queryString && queryString.length > 3) {
      //     getNormal({ companyName: queryString }).then((res) => {
      //       var restaurants = res.result
      //       // var restaurants = this.restaurants;
      //       var results = queryString
      //         ? restaurants.filter(this.createStateFilter(queryString))
      //         : restaurants
      //       console.log(results)
      //       clearTimeout(this.timeout)
      //       this.timeout = setTimeout(() => {
      //         cb(results)
      //       }, 100 * Math.random())
      //     })
      //   }
      // },

      createStateFilter(queryString) {
        return (state) => {
          return state.value.indexOf(queryString) === 0
        }
      },
      handleSelect(item) {
        console.log(item)
        this.userParams.code = item.creditCode
      },
      // 分会场同一时刻禁用
      placeChange(val) {
        this.disabledMeetingPlaceId = []
        let id = val[val.length - 1]
        for (let i = 0; i < val.length; i++) {
          let item = this.meetingPlaceDTOs.filter(item => item.id == val[i])
          if (item && item[0] && item[0].disabledMeetingPlaceId) {
            this.disabledMeetingPlaceId.push(...item[0].disabledMeetingPlaceId)
          }
        }
        this.$forceUpdate();
        console.log('aa', this.disabledMeetingPlaceId)
      },
      // 检查是否禁用
      disabledPlaceId(id) {
        let list = []
        if (this.disabledMeetingPlaceId[0]) {
          list = this.disabledMeetingPlaceId.filter(item => item == id)
          if (list[0]) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }


      },
      // 是否预定
      noOrder() {
        if (this.Checkbox_checkbox_1 == 1) {
          this.roomNum = 0
          for (let i = 0; i < this.meetingHotelDTOs.length; i++)
            this.meetingHotelDTOs[i].HotelParamsList.forEach((element) => {
              element.orderNum = 0
              element.endDate = null
              element.startDate = null
            })
        }
      },
      // 订房时间
      formatDate(date) {
        date = new Date(date)
        return `${date.getFullYear()}-${this.format(
          date.getMonth() + 1
        )}-${this.format(date.getDate())}`
      },
      format(n) {
        return n < 10 ? "0" + n : "" + n
      },
      onConfirm1(value) {
        this.showcalendar1 = false
        if (this.HotelParamsList[0].endDate) {
          let end = new Date(this.HotelParamsList[0].endDate)
          let start = new Date(this.formatDate(value))
          if (start.getTime() > end.getTime()) {
            Toast("入住时间要早于退房时间")
            return
          }
        }
        this.HotelParamsList[0].startDate = this.formatDate(value)
      },
      onConfirm2(value) {
        this.showcalendar2 = false
        if (this.HotelParamsList[0].startDate) {
          let start = new Date(this.HotelParamsList[0].startDate)
          let end = new Date(this.formatDate(value))
          if (start.getTime() > end.getTime()) {
            Toast("退房时间要晚于入住时间")
            return
          }
        }
        this.HotelParamsList[0].endDate = this.formatDate(value)
      },
      onConfirm3(value) {
        this.showcalendar3 = false
        if (this.HotelParamsList[1].endDate) {
          let end = new Date(this.HotelParamsList[1].endDate)
          let start = new Date(this.formatDate(value))
          if (start.getTime() > end.getTime()) {
            Toast("入住时间要早于退房时间")
            return
          }
        }
        this.HotelParamsList[1].startDate = this.formatDate(value)
      },
      onConfirm4(value) {
        this.showcalendar4 = false
        if (this.HotelParamsList[1].startDate) {
          let start = new Date(this.HotelParamsList[1].startDate)
          let end = new Date(this.formatDate(value))
          if (start.getTime() > end.getTime()) {
            Toast("退房时间要晚于入住时间")
            return
          }
        }
        this.HotelParamsList[1].endDate = this.formatDate(value)
      },
      changeSingle(value, type) {
        this.$nextTick(() => {
          console.log("单间", value, type)
          if (value == "0") {
            //不預定
            this.singleStatus = false
            this.disabledHotel = false
            // this.faultForm.repairTime = ''
            //清空校验
            this.$refs.submitHotel.resetValidation("singleIn")
            this.$refs.submitHotel.resetValidation("singleOut")
            this.HotelParamsList[type].startDate = null
            this.HotelParamsList[type].endDate = null
          } else {
            //預定
            console.log(this.HotelParamsList)
            this.HotelParamsList[type].orderNum = value
            this.singleStatus = true
            this.HotelParamsList.forEach((element) => {
              if (element.orderNum > 0) {
                this.disabledHotel = true
                return
              }
            })

          }
        })
      },
      changeSimple(value, type) {
        this.$nextTick(() => {
          console.log("标间", value)
          if (value == "0") {
            //不預定
            this.simpleStatus = false
            this.disabledHotel = false
            //清空校验
            this.$refs.submitHotel.resetValidation("simpleIn")
            this.$refs.submitHotel.resetValidation("simpleOut")
            this.HotelParamsList[type].startDate = null
            this.HotelParamsList[type].endDate = null
          } else {
            //預定
            this.simpleStatus = true
            this.HotelParamsList[type].orderNum = value
            this.HotelParamsList.forEach((element) => {
              if (element.orderNum > 0) {
                this.disabledHotel = true
                return
              }
            })
          }
        })
      },
      //  close(){
      //   if(!( /^[0-9a-zA-Z]{15}|^[0-9a-zA-Z]{18}|^[0-9a-zA-Z]{20}$/.test(this.invoiceParams.tin))){
      //     Toast.fail("请输入正确的纳税人识别号！");
      //     return false;
      //     this.showBottom=true
      //     console.log('hh')
      //   } else{
      //     console.log('hh')
      //     this.showBottom=false
      //   }
      //  },
      //  onBeforeClose(action, done) {
      //    if (action === "confirm") {
      //      return done(false);
      //    } else {
      //      // 重置表单校验
      //      this.$refs["myform"].resetValidation("name");
      //      this.name= undefined;
      //      return done();
      //    }
      //  },
      closeHotel() {
        this.showHotel = false
        // this.HotelParamsList[1].orderNum = 0
        // this.HotelParamsList[0].orderNum = 0
      },
      submitHotel() {
        console.log("hotel", this.HotelParamsList)
        this.$refs.submitHotel
          .validate()
          .then(() => {
            //成功时的程序
            console.log("chengg")
            this.roomNum = 0
            for (let i = 0; i < this.meetingHotelDTOs.length; i++) {
              let num =
                this.meetingHotelDTOs[i].HotelParamsList[0].orderNum +
                this.meetingHotelDTOs[i].HotelParamsList[1].orderNum
              this.roomNum = this.roomNum + num
            }
            this.showHotel = false
          })
          .catch(() => {
            //失败时的程序
            console.log("shibai")
            return
          })
      },
      // 验证码
      async getCode() {
        let mobile = this.userParams.mobile
        // !this.userParams.code ||
        if (
          !this.userParams.mobile ||
          !this.userParams.pic ||
          !this.userParams.name ||
          !this.userParams.province
        ) {
          return
        }
        if (this.isSpend) {
          return
        }
        if (!this.$regexp.mobile(mobile)) {
          Toast("请输入正确的手机号！")
          return false
        }
        getMobileLoginCode({ mobile }).then((res) => {
          if (res.success) {
            this.isSpend = true
            this.time = 30
            this.count()
          }
        })
      },
      count() {
        --this.time
        if (this.time > 0) {
          setTimeout(() => {
            this.count()
          }, 1000)
        } else {
          this.isSpend = false
        }
      },
      checkCode() {
        if (
          this.userParams.messageCode &&
          this.userParams.messageCode.length == 4
        ) {
          if (sessionStorage.getItem("openid")) {
            this.userParams.openid = sessionStorage.getItem("openid")
          }
          // checkRegisterCode(this.userParams).then((res) => {
          //   if (res.success) {
          //     this.submit(res.result.user.mobile)
          //     window.localStorage.setItem(
          //       "userInfo",
          //       JSON.stringify(res.result.group)
          //     )
          //     this.memberId = res.result.group.id
          //     sessionStorage.setItem("memberId", res.result.group.id)
          //     this.codeStatus = true
          //   } else {
          //     Toast.fail("验证码错误")
          //   }
          // })
        }
      },
      submit(mobile) {
        var params = {
          username: mobile + "," + 2,
          password: mobile,
          grant_type: "sms",
          userType: 2,
          scope: "server",
          client_id: "mms_meeting",
          client_secret: 123456,
          mobile: mobile,
          code: this.userParams.messageCode,
        }
        this.securityCheck(params)
          .then((res) => { })
          .catch((res) => { })
      },
      // 打开发票
      addinvoice() {
        if (!this.invoiceParams.invoiceCompanyName) {
          this.invoiceParams.invoiceCompanyName = this.userParams.name
        }
        this.showBottom = true
      },
      // 保存选填
      saveNorequired() {
        let num = 0
        if (this.invoiceParams.invoiceBank) {
          num = num + 1
        }
        if (this.invoiceParams.invoiceAccount) {
          num = num + 1
        }
        if (this.invoiceParams.invoiceAddress) {
          num = num + 1
        }
        if (this.invoiceParams.invoiceTelephone) {
          num = num + 1
        }
        if (this.invoiceParams.invoiceRemarks) {
          num = num + 1
        }
        let str = this.invoiceParams.invoiceRemarks
        let count = str.length
        console.log("111", count) // 输出：13
        this.invoiceParams.info = "已填写" + num + "项"
        this.show = false
      },
      // 提交开票信息
      admitInvoice() {
        if (this.invoiceParams.type == 2) {
          if (!/^[0-9a-zA-Z]{1,20}$/.test(this.invoiceParams.tin)) {
            Toast.fail("请输入正确的纳税人识别号！")
            return false
          }
        }
        this.$refs.admitInvoice
          .validate()
          .then(() => {
            //成功时的程序
            console.log(this.invoiceParams)
            let obj = this.INVOICE_TYPE.filter(
              (item) => item.value == this.invoiceParams.invoiceType
            )
            let typeName = obj.length ? obj[0].name : ""
            this.userParams.invoiceInfo =
              typeName + "-" + this.invoiceParams.invoiceCompanyName
            this.showBottom = false
          })
          .catch(() => {
            //失败时的程序
            // Toast.fail(err)
          })
      },



      submitRegister() {
        if (this.meetingDetail.duesType != 1) {
          if (this.invoiceParams.type == 1 && !this.invoiceParams.invoiceCompanyName) {
            Toast.fail("发票信息不能为空!")
            return
          }
          if (this.invoiceParams.type == 2 && (!this.invoiceParams.invoiceCompanyName || !this.invoiceParams.tin)) {
            Toast.fail("发票信息不能为空!")
            return
          }
        }
        //验证表单必填内容
        let valid = this.$refs["personValidate"].validateForm()
        if (!valid) {
          return
        }
        // 校验
        if (this.personDetailForm.mobile) {
          if (!this.$regexp.mobile(this.personDetailForm.mobile)) {
            Toast(`请输入正确的手机号码`)
            return
          }
        }
        if (this.personDetailForm.email) {
          if (!this.$regexp.email(this.personDetailForm.email)) {
            Toast(`请输入正确的邮箱地址`)
            return
          }
        }

        this.$router.push({ name: "Paypage" });
        this.submitdisabled = true
        let hotelList = {}
        if (!this.Checkbox_checkbox_1 == 1) {
          for (let i = 0; i < this.meetingHotelDTOs.length; i++) {
            for (let j = 0; j < this.meetingHotelDTOs[i].HotelParamsList.length; j++) {
              if (this.meetingHotelDTOs[i].HotelParamsList[j].orderNum > 0)
                hotelList = this.meetingHotelDTOs[i].HotelParamsList[j]
            }
          }
        }
        let params = {
          memberId: sessionStorage.getItem("memberId"),
          meetingId: this.meetingId,
          ...this.personDetailForm,
          invoiceTin: this.invoiceParams.tin,
          invoiceTitleType: this.invoiceParams.type,
          invoiceCompanyName: this.invoiceParams.invoiceCompanyName,
          invoiceType: this.invoiceParams.invoiceType,
          invoiceBank: this.invoiceParams.invoiceBank,
          invoiceAccount: this.invoiceParams.invoiceAccount,
          invoiceTelephone: this.invoiceParams.invoiceTelephone,
          invoiceRemarks: this.invoiceParams.invoiceRemarks,
          invoiceAddress: this.invoiceParams.invoiceAddress,
          deliveryType: 3,
          hotelId: hotelList.hotelId,
          checkInTime: hotelList.startDate,
          checkOutTime: hotelList.endDate,
          roomType: hotelList.roomType,
          meetingPlaceIds: this.PlaceParams.join(',')

        }
        this.settingPersonDetail.forEach(item => {
          if (item.editorType == 13) {
            params[item.field] = this.personDetailForm[item.field].join(',')
          }
        })
        console.log("params", params)
        signeGroupRegister(params).then((res) => {
          console.log(res)
          if (res.success) {
            //增加报名成功修改基本信息接口
            let userUpdateParams = {
              name: this.personDetailForm.name,
              pic: this.personDetailForm.pic,
              province: this.personDetailForm.province,
              mobile: this.personDetailForm.mobile,
            }

            // if (this.meetingDetail.duesType == 1) { //免费会议
            //   this.$router.push({
            //     name: "signUpsuccessM",
            //     query: { sourceName: "meetingManagerList", route: 1 },
            //   })
            // } else if (res.result.meetingGroupRegister.meetingGroupRegisterStatus == 9) {
            //   this.$router.push({
            //     name: "signUpsuccess",
            //     query: { sourceName: "meetingManagerList", route: 1 },
            //   })
            // } else {
            //   sessionStorage.setItem("signupPayList", JSON.stringify(res.result))
            //   this.$router.push({
            //     name: "signupPayList",
            //     query: {
            //       orderId: res.result.orderInfo.id,
            //       amount: res.result.orderInfo.amount,
            //       orderNo: res.result.orderInfo.orderNo,
            //       sourceName: "signUpPage",
            //     },
            //   })
            // }
            this.submitdisabled = false
          } else {
            Toast.fail(res.message)
            this.submitdisabled = false
          }
        })
      },
      getShengName(value) {
        let obj = this.sheng.find((item) => item.value === value)
        if (obj) {
          return obj.name
        } else {
          return ""
        }
      },
      getCityName(value) {
        let obj = this.allAddress.find((item) => item.value === value)
        if (obj) {
          return obj.name
        } else {
          return ""
        }
      },
      showAddressPicker() {
        this.columns = [
          {
            values: this.sheng,
            className: "column1",
          },
          // {
          //   values: this.shi1,
          //   className: "column2",
          // },
        ]
        this.selectKey = "province"
        this.selectModel = true
      },
      onCancel() {
        this.selectModel = false
      },
      onChange(picker, values, index) {
        if (this.selectKey === "province") {
          let city = this.allAddress.filter((item) => {
            return item.parentId === values[0].id
          })
          if (index === 0) {
            picker.setColumnValues(1, city)
          }
        }
      },
      onConfirm(item) {
        this.selectModel = false
        if (this.selectKey === "province") {
          this.userParams.province = item[0].value
          // this.userParams.city = item[1] ? item[1].value : "";
        }
        this.pickerField = undefined
        this.selectKey = undefined
      },
      getPersonInfo() {
        getMeetingSettings({
          meetingId: this.meetingId,
          templateId: "8a0feeda-a868-4af8-88b1-676d069fed72",
        }).then((resp) => {
          if (resp.success) {
            console.log('settingPersonDetail', resp)
            this.settingPersonDetail = resp.result
          }
        })
      },
      changeInvoiceType(value) {
        if (value == 2) {
          this.invoiceParams.invoiceCompanyName = this.userParams.name
          this.invoiceParams.tin = this.userParams.code
        } else {
          this.invoiceParams.invoiceCompanyName = ""
          this.invoiceParams.tin = ""
        }
      },
      showHotelClick(hotel) {
        console.log(hotel)
        this.HotelParamsList = hotel.HotelParamsList
        this.showHotel = true
      },
      copyRegisterInfo() {
        this.meetingGroupRegisterId =
          this.$route.query && this.$route.query.meetingGroupRegisterId
        if (!this.meetingGroupRegisterId) {
          return
        }
        // getRegisterdetail({
        //   meetingGroupRegisterId: this.meetingGroupRegisterId,
        //  }).then((res) => {
        //   if (res.success) {
        //     let registerInfo = res.result
        //     this.userParams.mobile = registerInfo.meetingGroupRegisterMobile
        //     this.invoiceParams.tin = registerInfo.invoiceTin
        //     this.userParams.pic = registerInfo.meetingGroupRegisterName
        //     this.userParams.name = registerInfo.meetingGroupRegisterCompanyName
        //     this.userParams.province = Number.parseInt(
        //       registerInfo.meetingGroupRegisterProvince
        //     )
        //     this.invoiceParams.invoiceType = registerInfo.invoiceType
        //     this.invoiceParams.deliveryType = registerInfo.deliveryType
        //     this.invoiceParams.invoiceCompanyName =
        //       registerInfo.invoiceCompanyName
        //     this.invoiceParams.invoiceBank = registerInfo.invoiceBank
        //     this.invoiceParams.invoiceAccount = registerInfo.invoiceAccount
        //     this.invoiceParams.invoiceTelephone = registerInfo.invoiceTelephone
        //     this.invoiceParams.invoiceRemarks = registerInfo.invoiceRemarks

        //     this.invoiceParams.invoiceAddress = registerInfo.invoiceAddress
        //     this.invoiceParams.deliveryContact = registerInfo.deliveryContact
        //     this.invoiceParams.type = registerInfo.invoiceTitleType
        //     this.invoiceParams.deliveryMobile = registerInfo.deliveryMobile
        //     this.invoiceParams.deliveryDetailedAddress =
        //       registerInfo.deliveryDetailedAddress
        //     this.invoiceParams.deliveryEmail = registerInfo.deliveryEmail
        //     //遍历数据设置报名人信息id为null
        //     if (
        //       registerInfo.meetingRegisterList &&
        //       registerInfo.meetingRegisterList.length > 0
        //     ) {
        //       registerInfo.meetingRegisterList.forEach((item) => {
        //         item.id = null
        //       })
        //     }
        //     this.personDetail = registerInfo.meetingRegisterList

        //     this.meetingHotelDTOs = registerInfo.hotelList
        //     let obj = this.INVOICE_TYPE.filter(
        //       (item) => item.value == this.invoiceParams.invoiceType
        //     )

        //     let typeName = obj.length ? obj[0].name : ""
        //     this.userParams.invoiceInfo =
        //       typeName + "-" + this.invoiceParams.invoiceCompanyName
        //     // this.meetingDetail.dues=registerInfo.price
        //     if (this.meetingHotelDTOs) {
        //       for (let i = 0; i < this.meetingHotelDTOs.length; i++) {
        //         //遍历数据设置预定酒店信息id为null
        //         if (
        //           registerInfo.hotelList[i].reservationInforList &&
        //           registerInfo.hotelList[i].reservationInforList.length > 0
        //         ) {
        //           registerInfo.hotelList[i].reservationInforList.forEach(
        //             (item) => {
        //               item.id = null
        //               item.meetingGroupRegisterId = null
        //             }
        //           )
        //         }
        //         this.meetingHotelDTOs[i].HotelParamsList =
        //           registerInfo.hotelList[i].reservationInforList
        //         this.meetingHotelDTOs[i].name =
        //           registerInfo.hotelList[i].hotelName
        //         this.meetingHotelDTOs[i].address =
        //           registerInfo.hotelList[i].hotelAddress
        //         this.meetingHotelDTOs[i].telephone =
        //           registerInfo.hotelList[i].concatMobile
        //         this.meetingHotelDTOs[i].hotelUrl =
        //           registerInfo.hotelList[i].website

        //         let num =
        //           this.meetingHotelDTOs[i].HotelParamsList[0].orderNum +
        //           this.meetingHotelDTOs[i].HotelParamsList[1].orderNum
        //         this.roomNum = this.roomNum + num
        //       }
        //       let arr = [
        //         "invoiceBank",
        //         "invoiceAccount",
        //         "invoiceAddress",
        //         "invoiceTelephone",
        //         "invoiceRemarks",
        //       ]
        //       var a = 0
        //       for (let i = 0; i < arr.length; i++) {
        //         let name = arr[i]
        //         if (this.invoiceParams[name] != null) {
        //           a += 1
        //         }
        //       }

        //       this.invoiceParams.info = "已填写" + a + "项"
        //     }

        //     this.index = this.personDetail.length
        //     this.amount = this.personDetail.length * this.meetingDetail.dues
        //     this.amount = Math.round(this.amount * 100) / 100
        //     // this.amount = registerInfo.orderInfo && registerInfo.orderInfo.amount;
        //   }
        // })
      },
      wechatLogin() {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?" +
          "appid=wx3bbb63b14bed5a2f" +
          "&redirect_uri=" +
          encodeURIComponent(
            "http://cacmbm.chinacacm.org/mobile/?id=" +
            this.meetingId +
            "#/signUpPage"
          ) +
          "&response_type=code" +
          "&scope=snsapi_userinfo" +
          "&state=meetingList" +
          "#wechat_redirect"
      },
      getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
        var r = window.location.search.substr(1).match(reg)
        if (r != null) return r[2]
        return ""
      },
      getO(code) {
        var params = {
          username: "",
          password: null,
          grant_type: "wx",
          userType: 2,
          scope: "server",
          client_id: "mms_meeting",
          client_secret: 123456,
          mobile: "",
          code: code,
        }
        this.securityCheck(params)
          .then((res) => {
            console.log("wxres", res)
            this.getUserInfo()
              .then((res) => {
                this.loginStatus = true
                this.setUserInfo() //设置用户信息回显
              })
              .catch(() => {
                Toast("用户信息获取失败")
              })
          })
          .catch((res) => {
            console.log("wxres", res)
            if (res.error_description == "999999") {
              Toast.fail("授权失败!")
            } else {
              sessionStorage.setItem("openid", res.error_description)
            }
          })
      },
      getUserInfo() {
        return new Promise((resolve) => {
          getUser().then((res) => {
            if (res.success) {
              this.userInfo = res.result
              window.localStorage.setItem(
                "userInfo",
                JSON.stringify(this.userInfo)
              )
              sessionStorage.setItem("memberId", res.result.id)
              this.memberId = res.result.id
              resolve()
            } else {
              Toast.fail("用户信息获取失败")
            }
          })
        })
      },
      setUserInfo() {
        let info = localStorage.getItem("userInfo")
        if (info) {
          this.userInfo = JSON.parse(info)
          this.personDetailForm.mobile = this.userInfo.mobile ? this.userInfo.mobile : ''
          this.personDetailForm.code = this.userInfo.code
          //   // this.personDetailForm.pic = this.userInfo.pic
          //   if (!this.personDetailForm.name) {
          this.personDetailForm.name = this.userInfo.name ? this.userInfo.name : ''
          //   }
          //   // this.personDetailForm.province = this.userInfo.province
        }
      },
    },
    mounted() {
      this.registerId = this.$route.query && this.$route.query.registerId
      this.meetingId = this.$route.query && this.$route.query.id
      let id = this.getQueryString("id")
      if (id) {
        if (this.$route.query && this.$route.query.id) {
          //优先用路由中的值
          this.meetingId = this.$route.query && this.$route.query.id
        } else {
          this.meetingId = id
        }
      }
      this.loginStatus = this.$route.query && this.$route.query.loginStatus
      if (this.meetingId) {


      }
      this.getMeeting()
      this.setUserInfo() //设置用户信息回显
      let memberId = sessionStorage.getItem("memberId")
      if (memberId) {
        this.memberId = memberId
      } else {
        //没有登录,拉起授权
        this.isMobile = window.navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) // 是否手机端
        this.isWx = /micromessenger/i.test(navigator.userAgent) // 是否微信

        this.code = this.getQueryString("code")
        this.stateRedirect = this.getQueryString("state")

        if (this.isMobile && this.isWx && !this.code) {
          this.wechatLogin()
        }

        if (this.code) {
          //code有值，代表重定向进入，根据授权获取用户信息
          this.getO(this.code)
        }
      }

      //重新报名，将数据分别赋值到对应的字段中
      this.copyRegisterInfo()

      this.getPersonInfo()
    },
  }
</script>
<style scoped lang="less">
  .page {
    position: relative;
    overflow: hidden;
    font-size: 0.48rem !important;
  }

  .group_1 {
    background-color: rgba(245, 245, 247, 1);
    padding-top: 18px;
    padding-bottom: 18px;
  }

  /deep/.el-popper {
    background: #fff !important;
    width: 104% !important;
    padding-left: 5%;
    /* height: 150px !important; */
  }

  /deep/.van-field__value {
    width: 76%
  }

  /deep/.van-cell__value {
    width: 76%;
    text-align: left;
  }

  /deep/.el-scrollbar__wrap {
    max-height: 150px;
    overflow: scroll;
  }

  /deep/.van-cell__right-icon {
    position: absolute;
    right: 15px;
  }

  /deep/input::-webkit-input-placeholder {
    color: #ccc;
  }

  /deep/.van-checkbox__icon .van-icon {
    width: 18px;
    height: 18px;
  }

  /deep/.label-justify {
    text-align-last: justify;
    padding-right: 17px;
  }

  .image_1 {
    width: 361px;
    height: 17px;
    margin: 0 16px 0 37px;
  }

  /deep/.van-field__control {
    /* width: auto; */
  }

  /* 
  /deep/.van-radio-group--horizontal {
    margin-left: 16px;
  } */

  /* /deep/.van-checkbox-group--horizontal {
    margin-left: 16px;
  } */

  /deep/.van-field--error .van-field__control::placeholder {
    color: #ccc;
  }

  /deep/.van-popup {
    overflow-x: hidden;
  }

  /deep/.van-field__control--right {
    text-align: left;
  }

  /deep/ .van-field__label,
  /deep/.van-cell__title {
    width: 3.1rem !important;
    color: #000;
    padding-left: 5px;
  }

  /deep/.van-cell--required .van-cell__title::after {
    position: static;
    color: transparent;
    font-size: 0.37333rem;
    content: "\A0*";
  }

  /deep/.van-button--default {
    border-color: transparent;
    position: absolute;
    top: -3px;
    right: 0px;
    padding: 0;
    margin: 0;
  }

  .hotel /deep/.van-field__value {
    width: auto;
    font-size: 12px;
  }

  .hotel {
    .group_2 {
      padding-bottom: 0;
      padding-top: 8px;
    }
  }

  .hotel /deep/.van-cell--required::before {
    position: static;
  }

  .holetinfo {
    padding: 0 16px 0 16px;
  }

  /deep/.van-divider {
    margin: 0;
  }

  .text-wrapper_2 {
    background-color: rgba(255, 255, 255, 1);
  }

  /deep/.van-collapse-item__title {
    background-color: rgba(230, 230, 232, 0.56);
  }

  /deep/.van-collapse-item {
    margin-bottom: 2px;
  }

  /deep/.van-cell::after {
    border-color: transparent !important;
    border-bottom: transparent;
  }

  /deep/.van-radio__icon--checked .van-icon {
    background-color: #1989fa;
    border-color: #1989fa;
  }

  /deep/.van-collapse-item__content {
    padding: 0;
  }

  /deep/.van-dialog {
    overflow: scroll !important;
  }

  /deep/.el-dialog {
    border-radius: 10px;
  }

  /deep/.el-input__inner {
    padding: 0;
    border-radius: 0;
    border: 0;
    height: 24px;
    color: #323233;
  }

  /deep/.el-dialog__body {
    padding-top: 0.2rem;
    border-radius: 10px;
  }

  .text-wrapper_2 {
    .more {
      /* /deep/.van-cell__title {
        padding-left: 15px;
      } */

      /* padding-left: 0; */
    }
  }

  /deep/.el-dialog {
    margin: auto;
    margin-top: 0 !important;
    top: 50%;
    transform: translateY(-50%);
  }

  /deep/.el-dialog__wrapper {
    overflow: hidden;
  }

  /deep/.el-dialog__body {
    max-height: 420px;
    overflow: hidden;
    padding: 0;
  }

  /deep/.van-field--min-height .van-field__control {
    min-height: 0.6rem;
  }

  /deep/.van-checkbox__icon--checked .van-icon {
    color: #fff;
    background-color: #1989fa;
    border-color: #1989fa;
  }

  /deep/.van-calendar__selected-day {
    background-color: #1989fa;
  }

  /deep/.van-button--danger {
    background-color: #1989fa;
    border: 0.02667rem solid #1989fa;
  }

  /deep/.van-radio--horizontal {
    margin-top: 3px;
    margin-bottom: 3px;
  }

  /deep/.van-checkbox--horizontal {
    margin-top: 3px;
    margin-bottom: 3px;
  }

  .moredialog {
    /deep/.van-field__value {
      width: 250px;
    }
  }

  .time {
    /deep/.van-field__control {
      text-align: right;
    }

    /deep/.van-field__error-message {
      text-align: right;
    }
  }

  .justify-between {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }

  .flex-row {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    flex-direction: row;
  }

  .codesms {
    /deep/.van-field__value {
      width: 62%;
    }
  }

  .group_28 {
    padding: 0 0 11px 0;
  }

  .nav-bar_2 {
    width: 411px;
    background: none;
    height: 44px;
  }

  .nav-bar_2 .van-nav-bar__content {
    height: 100%;
  }

  .nav-bar_2 .van-nav-bar__left {
    padding: 0 0 0 26px;
    align-items: start;
  }

  .label_1 {
    width: 26px;
    height: 26px;
    margin-top: 6px;
  }

  .nav-bar_2 .van-nav-bar__title {
    line-height: 22px;
  }

  .text_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    margin-top: 4px;
  }

  .box_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin: 0 5px 0 80px;
    padding: 16px 19px 16px 16px;
  }

  .titles {
    display: inline-block;
    width: 6px;
    height: 17px;
    line-height: 20px;
    background-color: #1989fa;
    text-align: center;
  }

  .titles-1 {
    padding: 9px 0 9px 16px;
    /* margin-right: 16px; */
    line-height: 20px;
    border-radius: 3px;
    background-color: rgba(242, 247, 255, 1);
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    text-align: left;
    font-family: Arial;
  }

  .paragraph_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    line-height: 26px;
  }

  .image-text_24 {
    width: 245px;
    margin: 16px 118px 0 0;
  }

  .icon_1 {
    width: 14px;
    height: 15px;
    margin: 2px 0 3px 0;
  }

  .text-group_1 {
    width: 223px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_2 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 5px 321px 0 15px;
  }

  .text_3 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .group-8 {
    padding: 16px;
  }

  .image-text_25 {
    width: 245px;
    margin: 16px 118px 0 0;
  }

  .icon_2 {
    width: 14px;
    height: 14px;
    margin: 0 0 2px 0;
  }

  .pagehotelcopy {
    width: 10px;
    height: 11px;
  }

  .text-group_2 {
    width: 223px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_4 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_5 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image-text_26 {
    width: 156px;
    margin: 16px 206px 0 1px;
  }

  .button-3 {
    background-color: #1989fa;
    border-radius: 28px;
    border: 1px solid #1989fa;
    padding: 2px 7px 1px 7px;
  }

  .text-70 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 17px;
  }

  .button-6 {
    background-color: rgba(250, 173, 122, 0.14);
    border-radius: 28px;
    border: 1px solid #1989fa;
    padding: 2px 7px 1px 7px;
  }

  .text-71 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .icon_3 {
    width: 12px;
    height: 16px;
    margin: 2px 0 2px 0;
  }

  .group_3 {
    margin-bottom: 35px;
  }

  .text-group_3 {
    width: 135px;
    height: 20px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_6 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_7 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .box_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0 0;
    position: relative;
    align-self: center;
    margin-top: -1px;
    margin: 0 8px 0 8px;
    padding: 16px 19px 0 16px;
  }

  .text_8 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-right: 47px;
  }

  .text-wrapper_8 {
    width: 111px;
    margin-top: 46px;
  }

  .text_11 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_12 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text-wrapper_9 {
    width: 95px;
    margin: 25px 16px 0 0;
  }

  .text_13 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_14 {
    width: 100%;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_15 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    padding: 0 0 0 0px;
    background: none;
    border: 0;
    flex: auto;
  }

  .input_1 {
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    width: 398px;
    position: absolute;
    left: 0;
    top: 72px;
    padding-left: 141px;
    padding-right: 141px;
  }

  .input_1 .van-field__body {
    height: 50px;
  }

  .text_16 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    padding: 0 0 0 0px;
    background: none;
    border: 0;
    flex: auto;
  }

  .text_17 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .button-1 {
    background-color: #1989fa;
    border-radius: 25px;
    margin: 60px 0 15px 17px;
    padding: 13px 0 13px 0;
  }

  .button-5 {
    background-color: #1989fa;
    border-radius: 22px;
    padding: 6px 53px 6px 53px;
  }

  .button_1 {
    background-color: #1989fa;
    border-radius: 25px;
    margin: 114px 0 0 0;
    width: 100%;
    padding: 13px auto;
  }

  .button-4 {
    width: 100%;
    background-color: #1989fa;
    border-radius: 22px;
    padding: 6px 53px 6px 53px;
  }

  .input_2 {
    position: absolute;
    left: 0;
    top: 121px;
    width: 398px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    padding-left: 141px;
    padding-right: 141px;
  }

  .input_2 .van-field__body {
    height: 50px;
  }

  .text_18 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_20 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    padding: 0 0 0 30px;
    background: none;
    border: 0;
    flex: auto;
  }

  .text_19 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 0;
  }

  .input_3 {
    position: absolute;
    left: 0;
    top: 170px;
    width: 398px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    padding-left: 16px;
  }

  .input_3 .van-field__body {
    height: 50px;
  }

  .text_21 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 1px;
  }

  .text_23 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    padding: 0 0 0 46px;
    background: none;
    border: 0;
    flex: auto;
  }

  .text_22 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 0;
  }

  .input_4 {
    position: absolute;
    left: 0;
    top: 219px;
    width: 398px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    padding-left: 16px;
  }

  .input_4 .van-field__body {
    height: 50px;
  }

  .dropdown_1 {
    border-radius: 0px 0px 4px 4px;
    position: absolute;
    left: 0;
    top: 268px;
    width: 398px;
    height: 50px;
    border: 1px solid rgba(255, 255, 255, 1);
    padding: 11px 9px 13px 15px;
  }

  .text_24 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_25 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 6px;
  }

  .text_26 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 46px;
  }

  .thumbnail_1 {
    width: 16px;
    height: 16px;
    margin: 5px 0 3px 133px;
  }

  /* .image-wrapper_5 {
  background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/254095396a3c4fc296bce50dbbf492be_mergeImage.png);
  height: 40px;
  width: 399px;
  position: absolute;
  left: 0;
  top: 36px;
} */

  .image_3 {
    width: 399px;
    height: 40px;
  }

  /* .button_6 {
  height: 22px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng23e038c296c9865e8b684bbd593a3d03c6f09545a2a9015b5ce7a40ef148f916)
    100% no-repeat;
  background-size: 100% 100%;
  width: 85px;
  position: absolute;
  left: 297px;
  top: 160px;
  padding: 2px 6px 1px 6px;
} */

  .text_79 {
    overflow-wrap: break-word;
    color: rgba(246, 109, 17, 0.51);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_29 {
    position: relative;
    padding: 16px 8px 11px 8px;
  }

  .group_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0 0;
    padding: 16px 10px 14px 16px;
  }

  .group-2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 16px 14px 14px 16px;
  }

  .text-wrapper_10 {
    margin-right: 340px;
  }

  .text_27 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .block_8 {
    margin-top: 22px;
  }

  .text_28 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-top: 2px;
  }

  .text_29 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 6px;
  }

  .text_30 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 46px;
  }

  .thumbnail_2 {
    width: 16px;
    height: 16px;
    margin: 3px 0 5px 147px;
  }

  .group_30 {
    margin-top: 16px;
  }

  .section_1 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 16px 0 36px 0;
  }

  .text_31 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 0 318px 0 16px;
  }

  .box_5 {
    background-color: rgba(230, 230, 232, 0.56);
    margin-top: 2px;
    padding: 9px 279px 9px 14px;
  }

  .text_32 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_33 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 1px;
  }

  .text-wrapper_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 36px;
    width: 398px;
    height: 50px;
    padding: 14px 179px 14px 16px;
  }

  .text_34 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_35 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 1px;
    padding-left: 2px;
  }

  .section_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    position: relative;
    margin-top: 14px;
    padding: 16px 0 35px 0;
  }

  .text_36 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 0 302px 0 60px;
  }

  .text_37 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .block_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin-top: 11px;
    padding: 13px 10px 14px 16px;
  }

  .icon_5 {
    width: 16px;
    height: 16px;
    margin: auto 5px;
  }

  .text_38 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 6px;
  }

  .text_39 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 27px;
  }

  .text_40 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 16px;
  }

  .thumbnail_3 {
    width: 16px;
    height: 16px;
    margin: 3px 0 4px 77px;
  }

  .block_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    position: absolute;
    left: 0;
    top: 98px;
    width: 398px;
    height: 50px;
    padding: 14px 10px 13px 16px;
  }

  .icon_6 {
    width: 16px;
    height: 16px;
    margin: 3px 0 4px 0;
    color: #1989fa;
  }

  .text_41 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 1px 0 0 10px;
  }

  .text_42 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin-left: 6px;
  }

  .text_43 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 2px 0 0 24px;
  }

  .thumbnail_4 {
    width: 16px;
    height: 16px;
    margin: 3px 0 4px 191px;
  }

  .text_44 {
    position: absolute;
    left: 42px;
    top: 15px;
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_45 {
    position: absolute;
    left: 57px;
    top: 14px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_46 {
    position: absolute;
    left: 139px;
    top: 16px;
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .group_5 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    height: 134px;
    margin-top: 112px;
    padding-top: 16px;
  }

  .block_9 {
    width: 330px;
    align-self: center;
  }

  .text_47 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .image-text_27 {
    margin: 3px 0 2px 0;
    display: flex;
    align-items: baseline;
  }

  .checkbox_1 {
    margin: -1.2000000476837158px 6px -0.20000004768371582px 0;
  }

  .text-group_4 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .block_5 {
    background-color: rgba(230, 230, 232, 0.56);
    width: 398px;
    margin-top: 11px;
    padding: 9px 16px 9px 14px;
  }

  .image-text_28 {
    width: 154px;
  }

  .thumbnail_5 {
    width: 16px;
    height: 16px;
    margin: 3px 0 3px 0;
  }

  .text-group_5 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_48 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
    margin-top: 3px;
  }

  .block_6 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    margin-top: -1px;
    padding: 14px 0 14px 0;
  }

  .block_1 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;
    width: 88%;

    padding: 20px 0 5px 16px;

    /deep/.van-cell__title .van-field__label {
      width: 2rem !important;
    }
  }

  /* .image-text_29 {
  width: 85px;
} */

  .icon_7 {
    width: 16px;
    height: 14px;
    margin: 6px 0 2px 0;
  }

  .text-group_6 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);

    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_49 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_6 {
    width: 16px;
    height: 16px;
    margin: 3px 0 3px 62px;
  }

  .group_6 {
    background-color: rgba(255, 255, 255, 1);
    margin-top: 4px;
    padding: 14px 10px 14px 19px;
  }

  .image-text_30 {
    width: 85px;
  }

  .icon_8 {
    width: 14px;
    height: 13px;
    margin: 7px 0 2px 0;
  }

  .text-group_7 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_50 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_7 {
    width: 10px;
    height: 11px;
  }

  .group_7 {
    background-color: rgba(255, 255, 255, 1);
    padding: 14px 10px 14px 17px;
  }

  .image-text_31 {
    width: 87px;
  }

  .icon_9 {
    width: 16px;
    height: 12px;
    margin: 5px 0 5px 0;
  }

  .text-group_8 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_51 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_8 {
    width: 10px;
    height: 11px;
  }

  .group_8 {
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    width: 398px;
    margin-top: 1px;
  }

  .text_52 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    display: flex;
    align-items: center;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .thumbnail_9 {
    width: 16px;
    height: 16px;
    margin-bottom: 1px;
  }

  .button-2 {
    display: flex;
    height: 22px;
    /* background: url(../../../assets/images/back.png) 100% no-repeat; */
    background-size: 100% 100%;
    right: 88px;
    padding: 2px 8px 1px 8px;
    border: 1px solid #1989fa;
    border-radius: 10px;
  }

  .text_53 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_9 {
    background-color: rgba(230, 230, 232, 0.56);
    padding: 9px 230px 9px 14px;
  }

  .image-text_32 {
    width: 154px;
  }

  .thumbnail_10 {
    width: 16px;
    height: 16px;
    margin: 3px 0 3px 0;
  }

  .text-group_9 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_10 {
    background-color: rgba(255, 255, 255, 1);
    margin-top: 49px;
    padding: 14px 10px 14px 18px;
  }

  .image-text_33 {
    width: 86px;
  }

  .icon_10 {
    width: 16px;
    height: 15px;
    margin: 5px 0 2px 0;
  }

  .text-group_10 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_54 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_11 {
    width: 10px;
    height: 11px;
  }

  .group_11 {
    background-color: rgba(255, 255, 255, 1);
    padding: 14px 10px 14px 18px;
  }

  .image-text_34 {
    width: 86px;
  }

  .icon_11 {
    width: 16px;
    height: 12px;
    margin: 6px 0 4px 0;
  }

  .text-group_11 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_55 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_12 {
    width: 10px;
    height: 11px;
  }

  .group_12 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 4px 4px;
    position: relative;
  }


  .text_56 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .thumbnail_13 {
    width: 16px;
    height: 16px;
    margin-bottom: 1px;
  }

  /* .button_3 {
  height: 22px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb7bc00fc956ca10018c0e2e7721c003a2db4c99fb128b8f68c1d1f28ce0e4e78)
    100% no-repeat;
  background-size: 100% 100%;
  width: 66px;
  position: absolute;
  left: 316px;
  top: 14px;
  padding: 2px 20px 1px 20px;
} */

  .text_57 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_13 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin-top: 16px;
    padding: 16px 0 8px 0;
  }

  .section_4 {
    width: 347px;
    margin: 14px 19px 0 8px;
  }

  .button_7 {
    width: 99px;
    height: 38px;
    border-radius: 19px;
    background-color: #1989fa;
    color: rgba(206, 206, 206, 1);
    font-size: 14px;
    text-align: center;
    font-family: Microsoft Yahei;
    border: 1px solid rgba(187, 187, 187, 1);
  }

  .text_9 {
    width: auto;
    margin: auto;
    text-align: center;
  }

  .button_8 {
    width: 231px;
    height: 38px;
    border-radius: 19px;
    background-color: #1989fa;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    text-align: center;
    font-family: Microsoft Yahei;
  }

  .text_58 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .checkbox_2 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: 1.7999999523162842px 0 1.7999999523162842px 242.79999995231628px;
  }

  .text_59 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
    margin: 3px 0 0 4.799999952316284px;
  }

  .section_5 {
    width: 322px;
    margin: 10px 60px 0 16px;
  }

  .icon_12 {
    background-color: rgba(250, 173, 122, 1);
    border-radius: 8px;
    margin-top: 1px;
    padding: 2px 5px 2px 5px;
  }

  .text_60 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    font-family: JLinXin;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 12px;
  }

  .text_61 {
    overflow-wrap: break-word;
    color: rgba(250, 173, 122, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_16 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    position: relative;
    margin-top: 11px;
    padding: 8px 10px 8px 16px;
  }

  .image-text_35 {
    width: 192px;
    margin: 7px 0 7px 0;
  }

  .thumbnail_14 {
    width: 20px;
    height: 20px;
  }

  .text-group_12 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .icon_13 {
    width: 30px;
    height: 34px;
    margin-left: 55px;
  }

  .text_62 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 6px 0 0 26px;
  }

  .thumbnail_15 {
    width: 16px;
    height: 16px;
    margin: 9px 0 9px 46px;
  }

  .icon_14 {
    position: absolute;
    left: 352px;
    top: 8px;
    width: 30px;
    height: 33px;
  }

  .group_17 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin-top: 59px;
    padding: 16px 0 16px 0;
  }

  .box_8 {
    width: 366px;
    align-self: center;
  }

  .text_63 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .image-text_36 {
    width: 58px;
    margin: 3px 0 2px 0;
  }

  /deep/.el-dialog {
    .box-1 {
      width: 98%;
      align-self: center;
      margin-top: 40px;
      display: flex;
      border-radius: 10px;
      justify-content: center;
      position: absolute;
      bottom: 0;
      background-color: #fff;
    }
  }

  /deep/.van-dialog__content {
    .box-1 {
      width: 98%;
      align-self: center;
      margin-top: 40px;
      display: flex;
      border-radius: 10px;
      justify-content: center;
      bottom: 0;
      background-color: #fff;
    }
  }

  .checkbox_3 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -1.2000000476837158px 0 -0.20000004768371582px 0;
  }

  .text-group_13 {
    overflow-wrap: break-word;
    color: rgba(136, 136, 136, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_19 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    margin-top: 2px;
    padding: 14px 19px 14px 16px;
  }

  .text_64 {
    overflow-wrap: break-word;
    color: rgba(255, 89, 98, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_65 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 6px;
  }

  .image-text_37 {
    width: 58px;
    margin: 3px 0 2px 158px;
  }

  .thumbnail_16 {
    width: 16px;
    height: 16px;
    margin-top: 1px;
  }

  .text-group_14 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_38 {
    width: 46px;
    margin: 3px 0 2px 30px;
  }

  .thumbnail_17 {
    width: 16px;
    height: 16px;
    margin-top: 1px;
  }

  .text-group_15 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .box_9 {
    margin: 9px 16px 0 31px;
  }

  .text_66 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .image-text_39 {
    width: 46px;
    margin: 2px 0 1px 105px;
  }

  .box_6 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_16 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_40 {
    width: 46px;
    margin: 2px 0 1px 26px;
  }

  .checkbox_4 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_17 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_41 {
    width: 46px;
    margin: 2px 0 1px 26px;
  }

  .section_3 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_18 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .box_10 {
    width: 190px;
    margin: 15px 16px 0 192px;
  }

  .image-text_42 {
    width: 46px;
  }

  .block_7 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_19 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_43 {
    width: 46px;
  }

  .box_7 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_20 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .image-text_44 {
    width: 46px;
  }

  .group_22 {
    border-radius: 1px;
    width: 18px;
    height: 18px;
    border: 1.200000047683716px solid rgba(230, 230, 232, 1);
    margin: -0.20000004768371582px 0 -1.2000000476837158px 0;
  }

  .text-group_21 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .group_23 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 16px 155px 16px 16px;
  }

  .box_11 {
    width: 227px;
  }

  .text-wrapper_5 {
    width: 108px;
    height: 28px;
    margin-bottom: 14px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_67 {
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_68 {
    height: 28px;
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 20px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_69 {
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text-wrapper_6 {
    width: 103px;
    height: 28px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_70 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_71 {
    height: 28px;
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 20px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .text_72 {
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text-wrapper_7 {
    width: 139px;
    height: 28px;
    overflow-wrap: break-word;
    font-size: 0;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
    margin: 14px 85px 0 3px;
  }

  .text_73 {
    height: 28px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 20px;
  }

  .text_74 {
    height: 28px;
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 20px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .button_4 {
    background-color: #1989fa;
    border-radius: 28px;
    align-self: center;
    margin-top: 16px;
    width: 320px;
    padding: 13px 127px 13px 127px;
  }

  .button_4[disabled] {
    color: #1989fa;
    border: none;
    background-color: #c8c9cc;
  }

  .text_75 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_25 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 0px 0px 4px 4px;
    height: 83px;
    width: 398px;
    position: absolute;
    left: 8px;
    top: 425px;
    padding: 17px 48px 16px 30px;
  }

  .button_5 {
    border-radius: 28px;
    border: 1px solid #1989fa;
    padding: 13px 119px 13px 111px;
  }

  .text_76 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_26 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    position: absolute;
    left: 8px;
    top: 1196px;
    width: 398px;
    height: 50px;
    padding: 8px 10px 8px 16px;
  }

  .image-text_45 {
    width: 170px;
    margin: 6px 0 7px 0;
  }

  .thumbnail_18 {
    width: 20px;
    height: 20px;
    margin-bottom: 1px;
  }

  .text-group_22 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 1px;
  }

  .icon_15 {
    width: 30px;
    height: 34px;
    margin-left: 77px;
  }

  .text_77 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 6px 0 0 26px;
  }

  .thumbnail_19 {
    width: 16px;
    height: 16px;
    margin: 9px 0 9px 43px;
  }

  .icon_16 {
    position: absolute;
    left: 352px;
    top: 8px;
    width: 30px;
    height: 33px;
  }

  .group_27 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px 4px 0px 0px;
    position: absolute;
    left: 8px;
    top: 852px;
    width: 398px;
    height: 50px;
    padding: 14px 10px 14px 18px;
  }

  .image-text_46 {
    width: 86px;
  }

  .icon_17 {
    width: 16px;
    height: 14px;
    margin: 6px 0 2px 0;
  }

  .text-group_23 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_78 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin: 1px 0 0 35px;
  }

  .thumbnail_20 {
    width: 16px;
    height: 16px;
    margin: 3px 0 3px 62px;
  }

  .image_2 {
    width: 414px;
    height: 38px;
    margin-top: -1px;
  }
</style>
